/**
 * External Dependencies
 */
import 'jquery';
// import fxMachine from 'fxmachine';
// import barba from './barba';
import afterDOMLoad from './afterDOMLoad';
import './util/detect-user-tabbing';

import './hamburger-menu';
import './ga-events';

const msg =
  '%c Crafted with ♥︎ by Digital Swing %c https://www.digital-swing.com';
const styles = [
  'background-image: url(https://www.digital-swing.com/logo/logo-small-rounded.jpg)',
  'background-size:50px 50px',
  'background-repeat:no-repeat',
  'margin-left:12px',
  'padding-left:50px',
  'padding: 18px 18px 18px 50px',
  'font-size: 12px',
  'font-family: monospace',
  // "background: white",
  'display: inline-block',
  'color: black',
  // "padding: 8px 19px",
  'border: 1px dashed;',
].join(';');
const styles2 = ['background-color:red', 'background-size:100% 100%'].join(';');
// eslint-disable-next-line no-console
console.log(msg, styles, styles2);

// eslint-disable-next-line no-unused-vars
// fxMachine();

// barba.init();
$(window).on('load', () => {
  // Décommenter afterDOMLoad en cas de désactivation de barba
  afterDOMLoad();
});
